import $ from 'jquery'

UE.registerUI('button', function (editor, uiName) {
  //注册按钮执行时的command命令，使用命令默认就会带有回退操作
  editor.registerCommand(uiName, {
    execCommand: function () {
      // alert('execCommand:' + uiName)
    }
  });
  //创建一个button
  var btn = new UE.ui.Button({
    //按钮的名字
    name: '图片上传',
    //提示
    title: '图片上传',
    //添加额外样式，指定icon图标，这里默认使用一个重复的icon
    cssRules: 'background-position: -380px 0;',
    //点击时执行的命令
    onclick: function () {
      //这里可以不用执行命令,做你自己的操作也可
      var newInput = document.createElement("input");
      newInput.type = 'file'
      document.body.appendChild(newInput)
      newInput.click()
      if(window.navigator.userAgent.toLowerCase().indexOf('trident')>0){
        update()
      }else{
        $('body').on('change',newInput,function () {
          update()
        })
      }
      function update() {
        var img = newInput.files[0]
        console.log(img);
        var formdata = new FormData()
        formdata.append('file', img)
        $.ajax({
          url: '/rest-admin/admin/get_qiniu_token',
          data: {},
          type: 'GET',
          dataType: 'JSON',
          success: function (res) {
            console.log(res);
            var data = res
            if (data.code === '000') {
              var qiniu = data.content
              var upToken = qiniu.upToken
              var domain = qiniu.domain
              formdata.append('token', upToken)
              $.ajax({
                url: 'https://upload.qiniup.com/',
                data: formdata,
                processData: false,
                contentType: false,
                type: 'POST',
                dataType: 'JSON',
                success: function (ress) {
                  var data = ress
                  var img = 'https://' + domain + '/' + data.key
                  var html='<img src="'+img+'">'
                  editor.execCommand('inserthtml',html)
                  $('body').unbind()
                  $(newInput).remove()
                }
              })
            }
          }
        })
      }
    }
  });
  //当点到编辑内容上时，按钮要做的状态反射
  editor.addListener('selectionchange', function () {
    var state = editor.queryCommandState(uiName);
    if (state == -1) {
      btn.setDisabled(true);
      btn.setChecked(false);
    } else {
      btn.setDisabled(false);
      btn.setChecked(state);
    }
  });
  //因为你是添加button,所以需要返回这个button
  return btn;
});
